module.exports = __webpack_public_path__ + "static/media/تبخیری.91a5e526.jpg";